export const select_lng = [
  {
    language: 'English (India) ',
    text: 'en-IN',
    voice: 'en-IN-PrabhatNeural',
    gender: 'Male',
  },
  {
    language: 'English (India) ',
    text: 'en-IN',
    voice: 'en-IN-NeerjaNeural',
    gender: 'Female',
  },
  {
    language: 'Hindi (India)',
    text: 'hi-IN',
    voice: 'hi-IN-MadhurNeural',
    gender: 'Male',
  },
  {
    language: 'Hindi (India)',
    text: 'hi-IN',
    voice: 'hi-IN-SwaraNeural',
    gender: 'Female',
  },
  {
    language: 'Telugu (India)',
    text: 'te-IN',
    voice: 'te-IN-MohanNeural',
    gender: 'Male',
  },
  {
    language: 'Telugu (India)',
    text: 'te-IN',
    voice: 'te-IN-ShrutiNeural',
    gender: 'Female',
  },
  {
    language: 'Tamil (India)',
    text: 'ta-IN',
    voice: 'ta-IN-PallaviNeural',
    gender: 'Female',
  },
  {
    language: 'Tamil (India)',
    text: 'ta-IN',
    voice: 'ta-IN-ValluvarNeural',
    gender: 'Male',
  },
  {
    language: 'Kannada (India)',
    text: 'kn-IN',
    voice: 'kn-IN-SapnaNeural',
    gender: 'Female',
  },
  {
    language: 'Kannada (India)',
    text: 'kn-IN',
    voice: 'kn-IN-GaganNeural',
    gender: 'Male',
  },
  {
    language: 'Malayalam (India)',
    text: 'ml-IN',
    voice: 'ml-IN-MidhunNeural',
    gender: 'Male',
  },
  {
    language: 'Malayalam (India)',
    text: 'ml-IN',
    voice: 'ml-IN-SobhanaNeural',
    gender: 'Female',
  },
  {
    language: 'Marathi (India)',
    text: 'mr-IN',
    voice: 'mr-IN-AarohiNeural',
    gender: 'Female',
  },
  {
    language: 'Marathi (India)',
    text: 'mr-IN',
    voice: 'mr-IN-ManoharNeural',
    gender: 'Male',
  },
  {
    language: 'Gujarati (India)',
    text: 'gu-IN',
    voice: 'gu-IN-DhwaniNeural',
    gender: 'Female',
  },
  {
    language: 'Gujarati (India)',
    text: 'gu-IN',
    voice: 'gu-IN-NiranjanNeural',
    gender: 'Male',
  },
  {
    language: 'Bengali (India)',
    text: 'bn-IN',
    voice: 'bn-IN-BashkarNeural',
    gender: 'Male',
  },
  {
    language: 'Urdu (India)',
    text: 'ur-IN',
    voice: 'ur-IN-GulNeural',
    gender: 'Female',
  },
  {
    language: 'Urdu (India)',
    text: 'ur-IN',
    voice: 'ur-IN-SalmanNeural',
    gender: 'Male',
  },
  {
    language: 'Russian (Russia)',
    text: 'ru-RU',
    voice: 'ru-RU-SvetlanaNeural',
    gender: 'Female',
  },
  {
    language: 'Russian (Russia)',
    text: 'ru-RU',
    voice: 'ru-RU-DmitryNeural',
    gender: 'Male',
  },
  {
    language: 'Spanish (Spain)',
    text: 'es-ES',
    voice: 'es-ES-AbrilNeural',
    gender: 'Female',
  },
  {
    language: 'Spanish (Spain)',
    text: 'es-ES',
    voice: 'ees-ES-AlvaroNeural',
    gender: 'Male',
  },
  {
    language: 'Chinese (Taiwanese Mandarin)',
    text: 'zh-TW',
    voice: 'zh-TW-HsiaoChenNeural',
    gender: 'Female',
  },
  {
    language: 'French (Belgium)',
    text: 'fr-BE',
    voice: 'fr-BE-CharlineNeural',
    gender: 'Female',
  },
  {
    language: 'Arabic (United Arab Emirates)',
    text: 'ar-AE',
    voice: 'ar-AE-FatimaNeural ',
    gender: 'Female',
  },
  {
    language: 'Arabic (United Arab Emirates)',
    text: 'ar-AE',
    voice: 'ar-AE-HamdanNeural ',
    gender: 'Male',
  },
  {
    language: 'Portuguese (Portugal)',
    text: 'pt-PT',
    voice: 'pt-PT-FernandaNeural',
    gender: 'Female',
  },
  {
    language: 'Sundanese (Indonesia)',
    text: 'su-ID',
    voice: 'su-ID-TutiNeural',
    gender: 'Female',
  },
  {
    language: 'Sundanese (Indonesia)',
    text: 'su-ID',
    voice: 'su-ID-JajangNeural',
    gender: 'Male',
  },
  {
    language: 'German (Austria)',
    text: 'de-AT',
    voice: 'de-AT-IngridNeural',
    gender: 'Female',
  },
  {
    language: 'German (Austria)',
    text: 'de-AT',
    voice: 'de-AT-JonasNeural',
    gender: 'Male',
  },
  {
    language: 'Japanese (Japan)',
    text: 'ja-JP',
    voice: 'ja-JP-AoiNeural',
    gender: 'Female',
  },
  {
    language: 'Japanese (Japan)',
    text: 'ja-JP',
    voice: 'ja-JP-DaichiNeural',
    gender: 'Male',
  },
  {
    language: 'Korean (Korea)',
    text: 'ko-KR',
    voice: 'ko-KR-InJoonNeural',
    gender: 'Male',
  },
  {
    language: 'Korean (Korea)',
    text: 'ko-KR',
    voice: 'ko-KR-JiMinNeural',
    gender: 'Female',
  },

  {
    language: 'Italian (Italy)',
    text: 'it-IT',
    voice: 'it-IT-IsabellaNeural',
    gender: 'Female',
  },
  {
    language: 'Italian (Italy)',
    text: 'it-IT',
    voice: 'it-IT-LisandroNeural',
    gender: 'Male',
  },
  {
    language: 'Turkish (Turkey)',
    text: 'tr-TR',
    voice: 'tr-TR-AhmetNeural',
    gender: 'Male',
  },
  {
    language: 'Turkish (Turkey)',
    text: 'tr-TR',
    voice: 'tr-TR-EmelNeural',
    gender: 'Female',
  },
  {
    language: 'Malay (Malaysia)',
    text: 'ms-MY',
    voice: 'ms-MY-OsmanNeural',
    gender: 'Male',
  },
  {
    language: 'Malay (Malaysia)',
    text: 'ms-MY',
    voice: 'ms-MY-YasminNeural',
    gender: 'Female',
  },
];

export const select_lng_obj2 = [
  {
    language: 'English (India) ',
    text: 'en-IN',
    voice: 'en-IN-PrabhatNeural',
    gender: 'Male',
  },
  {
    language: 'English (India) ',
    text: 'en-IN',
    voice: 'en-IN-NeerjaNeural',
    gender: 'Female',
  },
  {
    language: 'Hindi (India)',
    text: 'hi-IN',
    voice: 'hi-IN-MadhurNeural',
    gender: 'Male',
  },
  {
    language: 'Hindi (India)',
    text: 'hi-IN',
    voice: 'hi-IN-SwaraNeural',
    gender: 'Female',
  },
  {
    language: 'Telugu (India)',
    text: 'te-IN',
    voice: 'te-IN-MohanNeural',
    gender: 'Male',
  },
  {
    language: 'Telugu (India)',
    text: 'te-IN',
    voice: 'te-IN-ShrutiNeural',
    gender: 'Female',
  },
  {
    language: 'Tamil (India)',
    text: 'ta-IN',
    voice: 'ta-IN-PallaviNeural',
    gender: 'Female',
  },
  {
    language: 'Tamil (India)',
    text: 'ta-IN',
    voice: 'ta-IN-ValluvarNeural',
    gender: 'Male',
  },
  {
    language: 'Kannada (India)',
    text: 'kn-IN',
    voice: 'kn-IN-SapnaNeural',
    gender: 'Female',
  },
  {
    language: 'Kannada (India)',
    text: 'kn-IN',
    voice: 'kn-IN-GaganNeural',
    gender: 'Male',
  },
  {
    language: 'Malayalam (India)',
    text: 'ml-IN',
    voice: 'ml-IN-MidhunNeural',
    gender: 'Male',
  },
  {
    language: 'Malayalam (India)',
    text: 'ml-IN',
    voice: 'ml-IN-SobhanaNeural',
    gender: 'Female',
  },
  {
    language: 'Marathi (India)',
    text: 'mr-IN',
    voice: 'mr-IN-AarohiNeural',
    gender: 'Female',
  },
  {
    language: 'Marathi (India)',
    text: 'mr-IN',
    voice: 'mr-IN-ManoharNeural',
    gender: 'Male',
  },
  {
    language: 'Gujarati (India)',
    text: 'gu-IN',
    voice: 'gu-IN-DhwaniNeural',
    gender: 'Female',
  },
  {
    language: 'Gujarati (India)',
    text: 'gu-IN',
    voice: 'gu-IN-NiranjanNeural',
    gender: 'Male',
  },
  {
    language: 'Bengali (India)',
    text: 'bn-IN',
    voice: 'bn-IN-BashkarNeural',
    gender: 'Male',
  },
  {
    language: 'Urdu (India)',
    text: 'ur-IN',
    voice: 'ur-IN-GulNeural',
    gender: 'Female',
  },
  {
    language: 'Urdu (India)',
    text: 'ur-IN',
    voice: 'ur-IN-SalmanNeural',
    gender: 'Male',
  },
  {
    language: 'Russian (Russia)',
    text: 'ru-RU',
    voice: 'ru-RU-SvetlanaNeural',
    gender: 'Female',
  },
  {
    language: 'Russian (Russia)',
    text: 'ru-RU',
    voice: 'ru-RU-DmitryNeural',
    gender: 'Male',
  },
  {
    language: 'Spanish (Spain)',
    text: 'es-ES',
    voice: 'es-ES-AbrilNeural',
    gender: 'Female',
  },
  {
    language: 'Spanish (Spain)',
    text: 'es-ES',
    voice: 'ees-ES-AlvaroNeural',
    gender: 'Male',
  },
  {
    language: 'Chinese (Taiwanese Mandarin)',
    text: 'zh-TW',
    voice: 'zh-TW-HsiaoChenNeural',
    gender: 'Female',
  },
  {
    language: 'French (Belgium)',
    text: 'fr-BE',
    voice: 'fr-BE-CharlineNeural',
    gender: 'Female',
  },
  {
    language: 'Arabic (United Arab Emirates)',
    text: 'ar-AE',
    voice: 'ar-AE-FatimaNeural ',
    gender: 'Female',
  },
  {
    language: 'Arabic (United Arab Emirates)',
    text: 'ar-AE',
    voice: 'ar-AE-HamdanNeural ',
    gender: 'Male',
  },
  {
    language: 'Portuguese (Portugal)',
    text: 'pt-PT',
    voice: 'pt-PT-FernandaNeural',
    gender: 'Female',
  },
  {
    language: 'Sundanese (Indonesia)',
    text: 'su-ID',
    voice: 'su-ID-TutiNeural',
    gender: 'Female',
  },
  {
    language: 'Sundanese (Indonesia)',
    text: 'su-ID',
    voice: 'su-ID-JajangNeural',
    gender: 'Male',
  },
  {
    language: 'German (Austria)',
    text: 'de-AT',
    voice: 'de-AT-IngridNeural',
    gender: 'Female',
  },
  {
    language: 'German (Austria)',
    text: 'de-AT',
    voice: 'de-AT-JonasNeural',
    gender: 'Male',
  },
  {
    language: 'Japanese (Japan)',
    text: 'ja-JP',
    voice: 'ja-JP-AoiNeural',
    gender: 'Female',
  },
  {
    language: 'Japanese (Japan)',
    text: 'ja-JP',
    voice: 'ja-JP-DaichiNeural',
    gender: 'Male',
  },
  {
    language: 'Korean (Korea)',
    text: 'ko-KR',
    voice: 'ko-KR-InJoonNeural',
    gender: 'Male',
  },
  {
    language: 'Korean (Korea)',
    text: 'ko-KR',
    voice: 'ko-KR-JiMinNeural',
    gender: 'Female',
  },

  {
    language: 'Italian (Italy)',
    text: 'it-IT',
    voice: 'it-IT-IsabellaNeural',
    gender: 'Female',
  },
  {
    language: 'Italian (Italy)',
    text: 'it-IT',
    voice: 'it-IT-LisandroNeural',
    gender: 'Male',
  },
  {
    language: 'Turkish (Turkey)',
    text: 'tr-TR',
    voice: 'tr-TR-AhmetNeural',
    gender: 'Male',
  },
  {
    language: 'Turkish (Turkey)',
    text: 'tr-TR',
    voice: 'tr-TR-EmelNeural',
    gender: 'Female',
  },
  {
    language: 'Malay (Malaysia)',
    text: 'ms-MY',
    voice: 'ms-MY-OsmanNeural',
    gender: 'Male',
  },
  {
    language: 'Malay (Malaysia)',
    text: 'ms-MY',
    voice: 'ms-MY-YasminNeural',
    gender: 'Female',
  },
];
